<div class="vis-main">
  <div class="vis-column-select">
    <div *ngFor="let colConfig of visColumnConfigs" class="vis-column-select-line">
      <span class="column-display-name" title="{{getColumnTitle(colConfig)}}">
        <span *ngIf="isUserColumn(colConfig)" class="user-column-display-name">
          {{colConfig.display_name}}
        </span>
        <span *ngIf="!isUserColumn(colConfig)">
          {{colConfig.display_name}}
        </span>
      </span>
      <input type="checkbox" class="active-checkbox"
             title="Click to {{activeColumns[colConfig.name] ? 'hide' : 'show'}} this column"
             (change)="confSelectionChanged()"
             [(ngModel)]="activeColumns[colConfig.name]"/>
      <a *ngIf="isUserColumn(colConfig)"
         (click)="removeUserColumn(colConfig.name)"
         class="delete-user-link">
        <img title="Click to remove this column" src="/assets/delete_icon.svg"/>
      </a>
      <span *ngIf="showResults() && activeColumns[colConfig.name]">
        <a *ngIf="isCurrentSortField(colConfig.name)"
           title="Click to sort genes by this column"
           (click)="setSortBy(colConfig.name)">[sort]</a>
        <span *ngIf="!isCurrentSortField(colConfig.name)"
              title="Genes are currently sorted by {{colConfig.display_name}}" class="disabled-sort">
          [sort]
        </span>
      </span>
    </div>

    <div class="extra-column-control">
      <a (click)="configureExtraColumns()">Add column ...</a>
    </div>

    <div class="svg-download" *ngIf="showResults()">
      <a (click)="saveAsSVG()">Download image ...</a>
    </div>

    <div class="feature-size" *ngIf="showResults()">
      Scale image: <a (click)="changeLineHeight(-1)">[-]</a>
      <a *ngIf="lineHeight < 10" (click)="changeLineHeight(1)">[+]</a>
      <span *ngIf="lineHeight >= 10" >[+]</span>
    </div>
  </div>

  <ng-template #genePopover>
    <div *ngIf="currentGene">
    <div class="gene-name-and-product">
      <span class="gene-name">{{currentGene.getGeneShort().name}}</span> {{currentGene.getGeneShort().uniquename}}
      <span *ngIf="currentGene.getGeneShort().product">
        {{currentGene.getGeneShort().product}}
      </span>
    </div>
    <div *ngFor="let colConfig of visColumnConfigs">
      {{colConfig.display_name}}: {{currentGene.getField(colConfig.name)}}
    </div>
    </div>
  </ng-template>
  <ng-template #colPopover>
    <div *ngIf="currentData">
    <div>
      {{currentData.columnConfig.display_name}}: {{currentData.displayName}}
    </div>
    <div>
      {{countOfBin(currentData)}} in this bin highlighted
    </div>
    <div class="pop-up-help">
      (click to toggle selection)
    </div>
    </div>
  </ng-template>
  <div class="vis-results-and-selected">
  <div class="vis-results">
    <div *ngIf="!showResults()">
    <div *ngIf="!loading">
      (Select a column type from the list to the left)
    </div>
    <div *ngIf="loading" class="loading">
      Loading ...
    </div>
    </div>

    <div *ngIf="showResults()">
        <svg #visSVG [attr.width]="visTotalWidth()"
             [attr.height]="visTotalHeight()"
             xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg"
             id="gene-vis" overflow="visible">

          <style>
            .vis-gene {
              fill: #f0f0f0;
            }

            .vis-gene:nth-child(10n) {
              fill: #e0e0e0;
              stroke-width: 0;
              stroke: #9f9;
            }

            rect.vis-gene-selected {
              fill: #a0a0e0;
            }

            rect.vis-gene-selected:nth-child(10n) {
              fill: #9090d0;
            }

            rect.vis-column {
              fill-opacity: 0.8;
              stroke-width: 0;
            }

            .scale-label {
              font-size: 75%;
              text-anchor: end;
              fill: #666;
            }
            .col-label, .col-key-label {
              font-size: 80%;
            }
            .key-attr-value-rect {
              fill-opacity: 0.84;
            }
            .key-attr-value-text {
              font-size: 70%;
            }
          </style>

          <svg:text *ngFor="let idx of getScaleIndexes()" class="scale-label"
                    dy="0.4em"
                    attr.transform="translate({{leftMargin-3}} {{lineHeight * idx + colLabelHeight + 2}})">
            {{idx}}
          </svg:text>
          <svg:g *ngIf="lineHeight >= 1" style="pointer-events: all;">
            <svg:rect *ngFor="let geneData of getGeneDisplayData()"
                      class="vis-gene"
                  (click)="geneclick($event)"
                  (mouseenter)="geneEnter($event, geneData)"
                  (mouseleave)="geneLeave($event)"
                  [ngClass]="{'vis-gene-selected': selectedGenes[geneData.geneUniquename]}"
                  [attr.id]="geneData.id" [attr.height]="lineHeight"
                  [attr.width]="getGeneWidth() + activeColumnNames.length * (columnWidth + columnGap)"
                  [attr.x]="leftMargin"
                  [attr.y]="5 + colLabelHeight + geneData.geneIndex * lineHeight"
                  [popover]="genePopover"
                  triggers="mouseenter:mouseleave"
                  placement="right"
                  container="body"
                  style="pointer-events: inherit;">
            </svg:rect>
          </svg:g>

          <svg:g *ngFor="let columnName of activeColumnNames; let columnIndex = index">
            <svg:g>
              <title>Click to sort genes by this column</title>
            <svg:text class="col-label"
                      (click)="setSortBy(columnName)"
                      attr.transform="translate({{leftMargin + colLabelXOffset + getGeneWidth() + columnIndex * (columnWidth + columnGap) + columnGap}} {{colLabelHeight}}) rotate(-60)">
              {{visColumnConfigMap[columnName].display_name}}
            </svg:text>
            </svg:g>
            <svg:rect *ngFor="let columnData of getColumnDisplayDataMap()[columnName]"
                  class="vis-column"
                  (click)="dataClick($event, columnData)"
                  (mouseenter)="dataEnter($event, columnData)"
                  (mouseleave)="dataLeave($event)"
                  [attr.height]="lineHeight * (columnData.endIndex - columnData.startIndex + 1)"
                  [attr.width]="columnWidth"
                  [attr.x]="leftMargin + getGeneWidth() + columnIndex * (columnWidth + columnGap) + columnGap"
                  [attr.y]="5 + colLabelHeight + lineHeight * columnData.startIndex"
                  [attr.fill]="columnData.color"
                  [popover]="colPopover"
                  triggers="mouseenter:mouseleave"
                  placement="top"
                  container="body"
                  style="pointer-events: fill;">
            </svg:rect>
          </svg:g>
          <svg:g class="col-key" *ngFor="let columnName of activeColumnNames; let columnIndex = index">
            <svg:text class="col-key-label"
                      attr.transform="translate({{keyXPos()}} {{keyYPos(columnIndex)}})">
              {{visColumnConfigMap[columnName].display_name}}
            </svg:text>
            <svg:g *ngFor="let conf of attrValuesInUse[columnName]; let attrValIndex = index">
              <svg:rect class="key-attr-value-rect"
                        [attr.height]="keyRectHeight"
                        [attr.width]="keyRectWidth"
                        [attr.x]="keyXPos()"
                        [attr.y]="keyYPos(columnIndex) + attrValIndex * (keyRectHeight + keyAttrGap) + keyAttrGap + 3"
                        [attr.fill]="conf.color"
                        stroke-width="1"
                        [attr.stroke]="(keyHighlight == columnName + ':' + conf.attrValue) ? '#2229' : '#9999'"
                        style="pointer-events: fill;">
              </svg:rect>

              <svg:text class="key-attr-value-text"
                        [attr.x]="keyXPos() + keyRectWidth + keyAttrGap"
                        [attr.y]="keyYPos(columnIndex) + attrValIndex * (keyRectHeight + keyAttrGap) + keyAttrGap + keyRectHeight + 3"
                        fill="#555"
                        [style.font-weight]="(keyHighlight == columnName + ':' + conf.attrValue) ? 'bold' : 'normal'"
                        style="pointer-events: fill;">
                {{conf.displayName}}
              </svg:text>
            </svg:g>
          </svg:g>
        </svg>
    </div>
  </div>

  <div class="vis-selected-genes" *ngIf="selectedGeneList.length != 0">
    <div>
      <span class="vis-selected-genes-heading">
        {{selectedGenesDescription()}}
      </span>
      <span><a (click)="clearSelected()"> [clear]</a></span>
    </div>
    <div class="vis-selected-genes-list">
    <div class="vis-selected-genes-gene"
         *ngFor="let geneData of selectedGeneList.slice(0, geneListMaxLength)">
      <app-gene-link [gene]="geneData.getGeneShort()" [long]="false">
      </app-gene-link>
    </div>
    </div>
    <div *ngIf="selectedGeneList.length > geneListMaxLength">
      (and {{selectedGeneList.length - geneListMaxLength}} others)
    </div>
    <button class="btn btn-primary"
    title="Send selected genes to the advanced search page"
    (click)="sendToQueryBuilder()">Filter</button>
  </div>
  </div>
</div>
